angular.module('swapick')
.controller('UserInfoCtrl', UserInfoCtrl);

function UserInfoCtrl (DataService, $stateParams, initialLoaderManager,
  $ionicHistory, $state, $scope, DataStrategies) {

    this.tab = $stateParams.tab || 'info';

    if(this.tab == 'owned'){
      DataStrategies.createPagerMethods(this, $scope,
        {
          method:DataService.owned, pageSize:50,
          callMethodName:'getList', hasSearch:true,
          params : () => ({
            user_id : $stateParams.userId
          })
        }
      );

    }
    if(this.tab == 'wanted'){
      DataStrategies.createPagerMethods(
        this, $scope,
        {
          method:DataService.wanted, callMethodName:'getList', pageSize:50, hasSearch:true,
          params: () => ({ user_id : $stateParams.userId })
        }
      );
    }

    if(this.tab == 'canhave'){
      DataStrategies.createPagerMethods(
        this,
        $scope,
        {
          method: DataService.itemsIcanGet,
          callMethodName : 'get', hasSearch: true,
          itemsGetter: resp => resp.items,
          itemsTransformer : (items) => _.uniqBy(_.map(items, i=>{
            let p = i.posseduto_da;
            i.posseduto_da = [p]; return i; }
          ),'id'),
          params : () => (
            {
              swapper_id : this.user.id
            }
          )
        }
      );
    }



    this.loader = initialLoaderManager.makeLoader(()=> {

      return DataService.users
      .one($stateParams.userId)
      .one("info")
      .get()
      .then(u => {
        this.user = u;
        if(this.tab == 'owned' || this.tab == 'wanted' || this.tab == 'canhave') {
          return this.loadMore()
        }
        return u
      })

    });


    this.toTab = tab => {
      $ionicHistory.currentView($ionicHistory.backView());
      $ionicHistory.nextViewOptions({ disableAnimate: true });
      $state.go('app.logged.userinfo',
      {
          tab: tab, userId: this.user.id, userFromList:this.user
      },
      { location:'replace'});
    }

    this.goToUserSwaps = () => {
      $state.go('app.logged.user-swaps', { userId: this.user.id });
    };

    $scope.$on('$ionicView.beforeEnter', () => {
        this.loader.load();
    });

}



// WEBPACK FOOTER //
// ./src/controllers/user-info-controller.js